import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import ReactTable, { ReactTableDefaults } from 'react-table';

import { Image } from 'semantic-ui-react';

import {
  ReactTableFilterDatePicker,
  ReactTableSearch,
  ReactTablePagination,
  ReactTableHeaderText,
  Loading
} from 'components';

import * as common from 'libs/commonFunc';

import moment from 'moment';
import 'moment/locale/ko';
import 'moment/locale/ja';

import classNames from 'classnames/bind';
import styles from './ExamLeakPCList.css';
const cx = classNames.bind(styles);

moment.locale(localStorage.getItem('language'));

class ExamLeakPCList extends PureComponent {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { data, ...rest } = this.props;
    // 검색 (상단)
    const { searchObj } = this.props;
    // 필터
    const { handleChangeFilter, handleChangeDateFilter } = this.props;
    // 현재 페이지 이동 (하단)
    const { handlePagination } = this.props;

    const columns = [
      {
        Header: <ReactTableHeaderText title={'No'} />,
        accessor: 'infectionNo',
        sortable: true,
        resizable: false,
        minWidth: 72,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td text-align-center number-text')
      },
      {
        Header: <ReactTableHeaderText title={'PC'} />,
        accessor: 'hostname',
        sortable: true,
        minWidth: 143,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td')
      },
      {
        Header: <ReactTableHeaderText title={'IP'} />,
        accessor: 'ip',
        sortable: true,
        resizable: false,
        minWidth: 125,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakPCList_1', defaultMessage: '대상자' }))}
          />
        ),
        accessor: 'targetName',
        sortable: true,
        resizable: false,
        minWidth: 106,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakPCList_2', defaultMessage: '대상자 이메일' }))}
          />
        ),
        accessor: 'targetEmail',
        sortable: true,
        minWidth: 199,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakPCList_3', defaultMessage: '훈련 No' }))}
          />
        ),
        accessor: 'examNo',
        sortable: true,
        resizable: false,
        minWidth: 99,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center number-text')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakPCList_4', defaultMessage: '훈련명' }))}
          />
        ),
        accessor: 'examName',
        sortable: true,
        minWidth: 193,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'sub-text')
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamLeakPCList_13', defaultMessage: '감염 일시' }))}
              filter={
                <ReactTableFilterDatePicker
                  {...rest}
                  filter={searchObj.filterData}
                  onChange={data => {
                    handleChangeDateFilter('RegEpoch', data);
                  }}
                />
              }
            />
          );
        },
        accessor: 'regEpoch',
        minWidth: 177,
        sortable: true,
        resizable: false,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
          return value ? (
            <div>
              <span className={cx('start-date-normal')}>{moment.unix(value).format(dateFormat + ' HH:mm:ss')}</span>
              <span className={cx('start-date-fromnow')}>{moment.unix(value).fromNow()}</span>
            </div>
          ) : (
            ''
          );
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakPCList_5', defaultMessage: '총 감염 개수' }))}
          />
        ),
        accessor: 'leakAllcount',
        sortable: true,
        resizable: false,
        minWidth: 120,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-right sub-text')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakPCList_6', defaultMessage: '총 감염 크기' }))}
          />
        ),
        accessor: 'leakAllsize',
        sortable: true,
        resizable: true,
        minWidth: 120,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-right sub-text'),
        Cell: ({ value }) => {
          return common.humanFileSize(value);
        }
      },

      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakPCList_7', defaultMessage: '파일 개수' }))}
          />
        ),
        accessor: 'leakFileCount',
        sortable: true,
        resizable: false,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-right sub-text')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakPCList_8', defaultMessage: '파일 크기' }))}
          />
        ),
        accessor: 'leakFileSize',
        sortable: true,
        resizable: false,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-right sub-text'),
        Cell: ({ value }) => {
          return common.humanFileSize(value);
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakPCList_9', defaultMessage: '인증서 개수' }))}
          />
        ),
        accessor: 'leakCertCount',
        sortable: true,
        resizable: false,
        minWidth: 120,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-right sub-text')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakPCList_10', defaultMessage: '인증서 크기' }))}
          />
        ),
        accessor: 'leakCertSize',
        sortable: true,
        resizable: false,
        minWidth: 120,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-right sub-text'),
        Cell: ({ value }) => {
          return common.humanFileSize(value);
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakPCList_11', defaultMessage: '메일 개수' }))}
          />
        ),
        accessor: 'leakEmailCount',
        sortable: true,
        resizable: false,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-right sub-text')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakPCList_12', defaultMessage: '메일 크기' }))}
          />
        ),
        accessor: 'leakEmailSize',
        sortable: true,
        resizable: false,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-right sub-text last-text'),
        Cell: ({ value }) => {
          return common.humanFileSize(value);
        }
      }
    ];

    const { TbodyComponent: tbadyWrapper } = ReactTableDefaults;
    return (
      <div className={cx('react-table-area')}>
        <ReactTableSearch searchObj={searchObj} />
        <div className={cx('react-table')}>
          <ReactTable
            columns={columns}
            data={data}
            sortable={false}
            filterable={false}
            showPagination={false}
            showPageSizeOptions={false}
            defaultSorted={[
              {
                id: 'examNo',
                desc: true
              }
            ]}
            loadingText={defineMessages(formatMessage({ id: 'ExamLeakPCList_16', defaultMessage: '데이터 로딩중...' }))}
            LoadingComponent={({ ...rest }) => <Loading active={rest.loading} content={rest.loadingText} />}
            FilterComponent={({ ...rest }) => <div />}
            TbodyComponent={({ ...rest }) => (
              <div style={{ ...rest.style }} className={cx('react-table-tbody-wrapper')}>
                <tbadyWrapper {...rest} className={cx('rt-tbody', rest.className ? rest.className : '')} />
              </div>
            )}
            NoDataComponent={({ ...rest }) => (
              <div className={cx('noData-area')}>
                <Image src="/img/table/nodata_icon.png" />
                {defineMessages(formatMessage({ id: 'ExamTemplateList_24', defaultMessage: '데이터가 없습니다.' }))}
              </div>
            )}
            getTheadThProps={(state, rowInfo, column) => {
              const filter = [];
              if (column) {
                // 필터 처리
                if (typeof searchObj.filterData[column.id] !== 'undefined') {
                  filter.push('isFiltered');
                }
                // 정렬 제공 안하는 header
                if (!column.sortable) {
                  filter.push('no-sort');
                }

                return filter.length > 0
                  ? {
                      className: filter.join(' ')
                    }
                  : {};
              }
            }}
            {...rest}
          />
        </div>
        <ReactTablePagination
          currentPage={rest.page}
          totalPages={rest.pages ? rest.pages : 0}
          handlePagination={handlePagination}
        />
      </div>
    );
  }
}

export default injectIntl(ExamLeakPCList);



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamLeakPCList.js